"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e={styleOverrides:{root:{width:"328px"}}};exports.MuiDateCalendar=e;
